import {
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import {
  PostAllMacs
} from "../../api/api";
import { useState } from "react";

type GetMacsList = {
  open: boolean;
  authToken: string;
  mac: string;
};

type Macs = {
  Macs: string;
  // isDefaultTag: boolean;
  // occurrence: number;
};

type MacsList = {
  status: string;
  msg: Macs[];
};

export const useListMacs = ({
  open,
  authToken,
  mac,
}: GetMacsList): UseInfiniteQueryResult<
  MacsList,
  Error
> => {
  const [totalCount, setTotalCount] = useState(0);
  let limit = 25;

  return useInfiniteQuery({
    queryKey: ["listMacs", open, mac],
    initialPageParam: { skip: 0, limit },
    staleTime: 1000 * 60 * 5,
    queryFn: ({
      pageParam,
    }: {
      pageParam: { skip: number; limit: number };
    }) =>
      PostAllMacs({
        authToken,
        body: {
          device: pageParam,
          filter: {
            mac,
          },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken && !!open,
    getNextPageParam: (
      lastPage: MacsList,
      allPages: MacsList[]
    ) => {
      const totalFetched = allPages.flatMap(
        (page) => page.msg
      ).length;

      // Stop fetching if the total fetched rows reach or exceed the total count
      if (totalFetched >= totalCount) {
        return undefined;
      }

      // Return the skip value for the next page
      return { skip: allPages.length * limit, limit };
    },
  });
};
